import { $ } from "../../../vendor";
import InboomaBaseView from "../../views/InboomaBaseView";

import User from "../../models/User";

import VCardTpl from "../../templates/users/VCardTpl.html";

export default InboomaBaseView.extend({
  template: VCardTpl,

  templateContext() {
    return {
      centeredLayout: this.options.centeredLayout || false,
    };
  },

  initialize() {
    this.render();

    this.$el
      .find(".inb-user-badge")
      .css({ backgroundImage: "url(" + $("#MainLogo1").attr("src") + ")" });
  },
});
